import { useSelector } from '@xstate/react'
import { useLocationsService } from 'providers'
import { useEffect } from 'react'
import { LocationServiceMetaObject, TeachingLocation } from 'types/location'
import { useReadLocation } from './useReadLocation'

interface LocationWithCurrState
  extends TeachingLocation,
    LocationServiceMetaObject {}

export const useSingleLocation = (
  id: string = ''
): [TeachingLocation | undefined, boolean, string | undefined] => {
  const [read, , readLoading, readError] = useReadLocation()
  const [location, locationId] = useSelector(
    // @ts-ignore
    useLocationsService(),
    (state: any) => {
      return [state.context.content[id], id]
    },
    (a, b) => a[0] === b[0]
  ) as [LocationWithCurrState | undefined, string | undefined]

  const currentState = location?.__meta
  const loading = currentState?.status === 'pending' || readLoading
  const error =
    currentState?.status === 'failed'
      ? currentState.displayError
      : readError
      ? readError
      : undefined

  useEffect(() => {
    if (locationId && !location && !loading && !readError) {
      read({ id })
    }
  })

  delete location?.__meta

  return [location, loading, error]
}
